import { createFeatureSelector, createSelector } from '@ngrx/store';
import { appFeatureKey, State } from './app.reducer';
import { environment } from '#environment';

export const selectAppFeature = createFeatureSelector<State>(appFeatureKey);

export const selectKeyboardIsOpen = createSelector(selectAppFeature, (state) => state.keyboardIsOpen);

export const selectKeyboardOpenHeight = createSelector(selectAppFeature, (state) => state.keyboardOpenHeight);

export const selectKeyboardHeight = createSelector(selectAppFeature, (state) => state.keyboardHeight);

export const selectAppStatus = createSelector(selectAppFeature, (state) => state.appStatus);

export const appPushNotificationClicked = createSelector(selectAppFeature, (state) => state.pushNotification);

export const appDeepLinkClicked = createSelector(selectAppFeature, (state) => state.deepLink);

const authentication = environment.accessApp.deepLinks.authentication;

export const selectAppDeepLinkAuthenticationSuccess = createSelector(
  selectAppFeature,
  (state) => state.deepLink?.url === authentication.success
);

export const selectAppDeepLinkAuthenticationCancel = createSelector(
  selectAppFeature,
  (state) => state.deepLink?.url === authentication.cancel
);

export const selectAppDeepLinkAuthenticationError = createSelector(
  selectAppFeature,
  (state) => state.deepLink?.url === authentication.error
);

export const selectTabsHidden = createSelector(selectAppFeature, (state) => state.tabsHidden === true);

const paymentConfirmation = environment.accessApp.deepLinks.paymentConfirmation;

export const selectAppDeepLinkPaymentConfirmationUrlScheme = createSelector(selectAppFeature, (state) =>
  Object.values(paymentConfirmation).some((deeplink) => state.deepLink?.url === deeplink)
);
